
<template>
    <div class="modal action-modal"
        :class="{['minimized']: minimized}">
        <div class="modal-title hide-on-minimized">
            {{ title }}
            <div class="countdown-wrapper" v-if="!isActivePlayer()">
                <circular-countdown
                    v-if="this.updatedAt"
                    :startTime="this.updatedAt"
                    :durationInSeconds="45"
                />
            </div>
        </div>
        <div class="modal-content">
            <div class="modal-description" v-html="description">
            </div>
            <div class="options">
                <span v-for="(option, i) in options"
                    :key="`option-${i}-${option.value}`"
                >
                    <button class="btn btn-primary btn-3d"
                        @click="onCommand(actionType, option.value)"
                        v-if="!renderImage(option.label)"
                    >
                        {{ option.label }}
                    </button>
                    <img class="unit-img"
                        @click="onCommand(actionType, option.value)"
                        v-if="renderImage(option.label)"
                        :src="imgUrl(option.label)"
                    />
                </span>
            </div>
        </div>
        <span class="modal-toggle" @click="onToggleCallback('action')">
            <fa-icon
                icon="window-minimize"
                class="minimize-modal-icon"
                v-if="!minimized"
            />
            <fa-icon
                icon="chevron-up"
                class="maximize-modal-icon"
                v-if="minimized"
            />
        </span>
    </div>
</template>

<script>
import api from '../../helpers/api';
import { API_BASE_URL } from '@/helpers/env';

export default {
    props: ['minimized', 'onToggleCallback'],
    name: 'ActionModal',
    data() {
        return {
            refreshInterval: null,
            timeRemaining: null,
            title: 'Choose an action',
            updatedAt: null,
        };

    },
    async created() {
        const response = await api.request(`/game/${this.gameId}/snapshot/last`, 'GET');

        if (response.ok) {
            this.updatedAt = await response.json();
        }
    },
    beforeUnmount() {
        clearInterval(this.refreshInterval);
    },

    computed: {
        action() {
            return this.$store.state.actionsState.actionModal;
        },
        actionType() {
            return this.action ? this.action.type : '';
        },
        activePlayer() {
            return this.players.filter(player => player.id === this.$store.state.gameState.activePlayerId)[0];
        },
        isSpectator() {
            return this.$store.getters.isSpectator;
        },
        description() {
            return this.action ? this.action.description : '';
        },
        options() {
            return this.action ? this.action.options : [];
        },
        userId() {
            return this.$store.state.loginState.userId;
        },
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
        players() {
            return this.$store.state.gameState.players;
        },
        player() {
            return this.$store.getters.player;
        },
        assetsUrl() {
            return `${API_BASE_URL}/assets`;
        },
        decreeId() {
            return this.$store.state.actionsState.activeDecreeId;
        },
    },
    methods: {
        async onCommand(actionType, value) {
            await this.$store.dispatch('setSelectedOptionValue', value);
            await this.$store.dispatch('sendCommand',
                {
                    actionType,
                    gameId: this.gameId,
                    playerId: this.player.id,
                    $socket: this.$socket,
                    $notify: this.$notify,
                },
            );
        },
        renderImage(optionLabel) {
            return /^\w+\.png$/.test(optionLabel);
        },
        imgUrl(imageName) {
            return `${this.assetsUrl}/${imageName}`;
        },
        isActivePlayer() {
            return this.activePlayer &&
                this.player &&
                this.activePlayer.id === this.player.id &&
                !this.isSpectator;
        },
    },
};
</script>


<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .action-modal {

        .btn {
            margin: auto 12.5px;
        }

        .unit-img {
            cursor: pointer;
            height: 65px;
            width: 65px;
            margin: auto 7.5px;
        }

        .options {
            display: flex;
            justify-content: center;

            > * {
                align-self: center;
            }
        }

        .countdown-wrapper {
            left: 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }
    }

</style>
